import React from 'react';
import { FaGoogle, FaApple } from 'react-icons/fa';
import jakim2025 from '../../assets/jakim_2025.json';
import jakim2026 from '../../assets/jakim_2026.json';

const jakimData = [...jakim2025.prayerTime, ...jakim2026.prayerTime];

function LiveDate({ weddingDate, startTime, endTime, fontP, walimatulurus, groomName, brideName, directions }) {
  const storedLocations = JSON.parse(directions);
  const locationName = storedLocations[0].locationName;

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes} ${period}`;
  }

  function getDayFromDate(date) {
    const days = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', "Jumaat", 'Sabtu'];
    return days[date.getDay()];
  }

  function toMYDate(utcString) {
    const d = new Date(new Date(utcString).getTime() + 8 * 60 * 60 * 1000);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  function formatGoogleDateTime(dateStr, timeStr) {
    const [year, month, day] = dateStr.split('-');
    const [hour, minute] = timeStr.split(':');
    const localDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));
    return localDate.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  }

  // === Create .ics download ===
  function downloadICS() {
    const malaysiaDate = new Date(new Date(weddingDate).getTime() + 8 * 60 * 60 * 1000);
    const [startHour, startMin] = startTime.split(':');
    const [endHour, endMin] = endTime.split(':');

    const start = new Date(malaysiaDate);
    start.setHours(startHour);
    start.setMinutes(startMin);

    const end = new Date(malaysiaDate);
    end.setHours(endHour);
    end.setMinutes(endMin);

    const pad = (n) => String(n).padStart(2, '0');
    const formatICS = (d) =>
      `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${walimatulurus} ${groomName} & ${brideName}
DESCRIPTION:Jemputan ke ${walimatulurus} ${groomName} & ${brideName}
LOCATION:${locationName}
DTSTART:${formatICS(start)}
DTEND:${formatICS(end)}
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'event.ics';
    a.click();
    URL.revokeObjectURL(url);
  }

  const displayDate = new Date(weddingDate);
  const weddingDay = getDayFromDate(displayDate);
  const formattedDate = displayDate.toLocaleDateString('ms-MY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const formattedGregorianDate = displayDate.toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).replace(/ /g, '-');
  const entry = jakimData.find(item => item.date === formattedGregorianDate);
  let islamicDate = '';
  if (entry) {
    const [year, month, day] = entry.hijri.split('-');
    const hijriMonths = ['Muharam', 'Safar', 'Rabiulawal', 'Rabiulakhir', 'Jamadilawal', 'Jamadilakhir', 'Rejab', 'Syaban', 'Ramadan', 'Syawal', 'Zulkaedah', 'Zulhijjah'];
    islamicDate = `${day} ${hijriMonths[parseInt(month) - 1]} ${year} H`;
  } else {
    islamicDate = 'Date not found';
  }

  const startTimeNew = convertTo12HourFormat(startTime);
  const endTimeNew = convertTo12HourFormat(endTime);
  const malaysiaDate = toMYDate(weddingDate);

  let startUTC = '';
  let endUTC = '';
  let googleCalendarLink = '';

  try {
    startUTC = formatGoogleDateTime(malaysiaDate, startTime);
    endUTC = formatGoogleDateTime(malaysiaDate, endTime);

    const eventTitle = encodeURIComponent(`${walimatulurus} ${groomName} & ${brideName}`);
    const eventDetails = encodeURIComponent(`Jemputan ke ${walimatulurus} ${groomName} & ${brideName}`);
    const eventLocation = encodeURIComponent(locationName);

    googleCalendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startUTC}/${endUTC}&details=${eventDetails}&location=${eventLocation}&sf=true&output=xml`;
  } catch (error) {
    console.error('Invalid date/time format:', error);
  }

  return (
    <div className="text-center">
      <h1 className={`text-l mb-4 uppercase font-bold ${fontP}`}>Tarikh</h1>
      <p className={`text-l ${fontP}`}>{weddingDay}, {formattedDate}</p>
      <p className={`text-l ${fontP}`}>{islamicDate}</p>

      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>Masa</h1>
      <p className={`text-l ${fontP}`}>{startTimeNew} - {endTimeNew}</p>

      <div className="mt-6 flex justify-center gap-4">
        {googleCalendarLink && (
          <a
            href={googleCalendarLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-[#4285F4] border border-[#4285F4] px-4 py-2 rounded hover:bg-[#e8f0fe] transition"
          >
            <FaGoogle className="text-lg" />
            Calendar
          </a>
        )}

        <button
          onClick={downloadICS}
          className="inline-flex items-center gap-2 bg-[#000] text-white px-4 py-2 rounded hover:bg-gray-800 transition"
        >
          <FaApple className="text-lg" />
          Calendar
        </button>
      </div>
    </div>
  );
}

export default LiveDate;

